import api from "./index";
import { axios } from "@/utils/request";

export function createSeason(parameter) {
    console.log(parameter, api.BaseURL + api.Season + "create");
    return axios({
        url: api.BaseURL + api.Season + "create",
        method: "POST",
        data: parameter,
    });
}

export function getListSeason(parameter) {
    return axios({
        url: api.BaseURL + api.Season + "list",
        method: "GET",
        params: parameter,
    });
}

export function updateSeason(parameter) {
    return axios({
        url: api.BaseURL + api.Season + "update",
        method: "POST",
        data: parameter,
    });
}

export function approveRelease(parameter) {
    return axios({
        url: api.BaseURL + api.Season + "approve_release_version",
        method: "POST",
        data: parameter,
    });
}
export function exportData(parameter) {
    return axios({
        url: api.BaseURL + api.Season + "export_data_section",
        method: "POST",
        data: parameter,
    });
}

export function deleteSeason(parameter) {
    return axios({
        url: api.BaseURL + api.Season + "delete",
        method: "POST",
        data: parameter,
    });
}

export function releastBeta(parameter) {
    return axios({
        url: api.BaseURL + api.Season + 'create_beta',
        method: 'POST',
        data: parameter
    })
}